import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { ANALYTICS_ACTION_TYPES, ANALYTICS_ITEM_TYPES, ANALYTICS_OBJECT_TYPES } from '@fttb/common';
import { selectCommonAnalyticsData } from "../../../../analytics/selectors";
import { getIsFTTB } from "../../../../userRegion/selectors";
import { GOAL_FTTB_AND_FMC } from "../../constants";
import { getAnalyticsEventType } from "../../../selectors";
import { getAddressCheckModuleData } from "../../../../selectors";
import { FIRST_BUTTON_ACTIONS } from "../../analytics/constants";
import { selectIsCheckboxChecked } from "../../../../CheckboxAgreement/selectors";
import { selectIsCorrectCtn, selectIsFttbPersonalVerificationCheckboxEnable } from "../../../../callbackRequest/selectors";
import { selectButtonTexts, selectCurrentViewTexts } from "../../selectors";
import { selectFiasAddress } from "../../moduleSelectors";
import { sendParamsWithBlockName, sendYmReachGoal } from "../../analytics";

/** хендлер обработки аналитики при нажатии на кнопку отправки заявки на обратный звонок */
export var handleResultStep = function handleResultStep() {
  return function (_, getState) {
    var state = getState();
    var commonAnalyticData = selectCommonAnalyticsData(state);
    var address = selectFiasAddress(state);
    var address_check = getAddressCheckModuleData(state).status;
    var pageType = getAnalyticsEventType(state);
    var _selectCurrentViewTex = selectCurrentViewTexts(state),
      title = _selectCurrentViewTex.title;
    var _selectButtonTexts = selectButtonTexts(state),
      buttonText = _selectButtonTexts.buttonText;
    var _getAddressCheckModul = getAddressCheckModuleData(state),
      status = _getAddressCheckModul.status;
    var isCheckboxEnabled = selectIsFttbPersonalVerificationCheckboxEnable(state);
    var isValid = isCheckboxEnabled ? selectIsCheckboxChecked(state) && selectIsCorrectCtn(state) : selectIsCorrectCtn(state);
    var reachGoal = getIsFTTB(state) ? GOAL_FTTB_AND_FMC.HomeTariffCallbackLongForm : GOAL_FTTB_AND_FMC.ConvergentTariffCallbackLongFormNew;
    var reachGoalParams = {
      page_title: title
    };
    var action_id = FIRST_BUTTON_ACTIONS[status];
    if (isValid) {
      sendParamsWithBlockName(pageType, _objectSpread(_objectSpread({}, commonAnalyticData), {}, {
        action: ANALYTICS_ACTION_TYPES.click,
        item_type: ANALYTICS_ITEM_TYPES.button,
        object_type: ANALYTICS_OBJECT_TYPES.block,
        button_text: buttonText,
        block_title: title,
        address: address,
        address_check: address_check,
        action_id: action_id
      }));
      sendYmReachGoal(reachGoal, reachGoalParams);
    }
  };
};